export default __webpack_public_path__ + "static/IMGP1846-b070a9c46d7fcd610de4ae837c18aae6.jpg";